import { render, staticRenderFns } from "./ConsumptionsRoutesPage.vue?vue&type=template&id=84dace2e&"
import script from "./ConsumptionsRoutesPage.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionsRoutesPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports